export default __webpack_public_path__ + "static/media/sample-pickup.ab9d248c.svg";